import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import SW from "../../packages/gatsby-theme-language-book/exercise-builders/sentence-switch";
import { verbs, subjects, complements, predefinedVerbs } from "../data/unidad-2b-5.2-bilde-sätze.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Forma frases. (Bilde Sätze. Schreibe die Wörter für jeden Satz in die offenen Kästchen.)`}</p>
    <br />
Ejemplo:   
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`sujeto`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`verb`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`complemento`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Nosotros`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`vivimos`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`en Madrid.`}</td>
        </tr>
      </tbody>
    </table>
    <SW predefinedVerbs={predefinedVerbs} verbs={verbs} complements={complements} subjects={subjects} mdxType="SW" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      